import React from "react";
import AsiaPayoutOrchestrator from "../../shared/AsiaPayoutOrchestrator";
import { uaeConfig } from "./config";

const UAEPayout: React.FC = () => {
  return <AsiaPayoutOrchestrator config={uaeConfig} />;
};

export default UAEPayout;
